<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-rangregelung">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Rangregelung" | translate }}</h2>
  </ng-container>

  <cap-rangregelung-table [hasRight]="grundstueckEntry?.permissions?.rangregelungen && ersterfassungUebergeben" [listLoader]="loader">
  </cap-rangregelung-table>
</cap-rubrik>
